import { Auth } from "aws-amplify";
import React from "react";
import styled from "@emotion/styled";
import { defaultTheme as theme } from "@deliverr/ui/lib-esm/shared/theme";
import { useNavigate } from "react-router";

export const StyledSideBar = styled.td`
  vertical-align: top;
  width: 100px;
  background-color: ${theme.colors.BLUE[600]};
  color: white;
  font-family: ${theme.font.family.STANDARD};
  font-size: ${theme.font.size.F1};
  text-align: left;
  padding: ${theme.spacing.S3};
  padding-top: ${theme.spacing.S7};
  height: 100%;
`;

export const SideBar: React.FC = () => {
  const navigate = useNavigate();

  // TODO: Prefer signOut to be closer to Login page or separate Logout page instead of being in SideBar
  async function signOut() {
    localStorage.clear();
    await Auth.signOut();
    navigate("/Login");
  }

  return (
    <StyledSideBar>
      <div className="SideBar">
        <a style={{ color: "white" }} href="/LostUnits/List">
          View Lost Units
        </a>
        <br />
        <a style={{ color: "white" }} href="/LostUnits/Create">
          Record Lost Units
        </a>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <hr />
        <button onClick={signOut} className="signOutButton">
          SignOut
        </button>
      </div>
    </StyledSideBar>
  );
};
